import { Moment } from 'moment'
import { IAbsence } from '../../../HR/Absence/Client/IAbsence'


export const calcAbsenceTimeSlots = (
  absences: IAbsence[],
  personId: number,
  date: Moment,
  timeDivision: number,
): number[] => {
  const startDate = date.clone().startOf('day')
  const endOfDate = date.clone().endOf('day')

  return (
    absences
      .filter(
        absence =>
          absence.personId === personId &&
          startDate.isBefore(absence.endsAt) &&
          endOfDate.isAfter(absence.startsAt),
      )
      .map(absence => {
        let startSlot = 0
        if (absence.startsAt.isAfter(startDate)) {
          startSlot =
            Math.round(
              absence.startsAt.diff(startDate, 'minutes') / timeDivision,
            ) * timeDivision
        }

        let endSlot = 1440
        if (absence.endsAt.isBefore(endOfDate)) {
          endSlot =
            Math.round(
              absence.endsAt.diff(startDate, 'minutes') / timeDivision,
            ) * timeDivision
        }

        const slots = []
        for (let i = startSlot; i <= endSlot; i += timeDivision) {
          slots.push(i)
        }

        return slots
      })
      // TODO: Check alternate solution?
      .flat()
  )
}
